/**
 * @desc 详情信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CertMainInfoRequestDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/certMain/${id}/info`, {
      method: "GET",

      ...options,
    }),
  );
}
